import FormTabSwitcher from './form-tab-switcher';
export default FormTabSwitcher;
